import { Directive, ElementRef, OnInit } from '@angular/core';

import { SharedDataService } from '@shared/services/shared-data.service';

@Directive({
  selector: '[dbAuthorisation]'
})
export class AuthorisationDirective implements OnInit {
  userPermission: any;

  constructor(
    private sharedDataService: SharedDataService,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {
    this.checkPermissions();
  }

  checkPermissions() {
    if (!this.sharedDataService.userIsAdmin) {
      this.userPermission = false;
    } else {
      this.userPermission = this.sharedDataService.userIsAdmin;
    }

    if (!this.userPermission) {
      this.elementRef.nativeElement.parentElement.removeChild(this.elementRef.nativeElement);
    }
  }

}
